import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { isLanguageEnabled } from '../i18n/i18n';
import './LanguageSelector.css';

function LanguageSelector() {
  const { language, changeLanguage, translations } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = translations.languages || {
    en: 'English',
    de: 'Deutsch',
    fr: 'Français',
    it: 'Italiano',
    es: 'Español',
    zh: '中文',
    ko: '한국어',
    ar: 'العربية'
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLanguageChange = (lang) => {
    if (!isLanguageEnabled(lang)) return;
    changeLanguage(lang);
    setIsOpen(false);
  };

  return (
    <div className="language-selector" ref={dropdownRef}>
      <button
        className="language-selector-button"
        data-lang={language}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Select language"
        aria-expanded={isOpen}
      >
        <span className="language-name">{languages[language]}</span>
        <span className="language-arrow">{isOpen ? '▲' : '▼'}</span>
      </button>

      {isOpen && (
        <div className="language-dropdown">
          {Object.entries(languages).map(([code, name]) => {
            const enabled = isLanguageEnabled(code);
            const classes = [
              'language-option',
              code === language ? 'active' : '',
              enabled ? '' : 'disabled',
            ].filter(Boolean).join(' ');
            return (
              <button
                key={code}
                className={classes}
                data-lang={code}
                disabled={!enabled}
                aria-disabled={!enabled}
                title={enabled ? undefined : 'Coming soon'}
                onClick={() => handleLanguageChange(code)}
              >
                <span className="language-option-code">{code.toUpperCase()}</span>
                <span className="language-option-name">{name}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default LanguageSelector;
